import React from 'react';
import {View, StyleSheet, TextInput, TouchableOpacity, TextStyle, StyleProp} from 'react-native';
import {CloseIcon, Colors, onPressOpacity, Pill, SearchIcon, Sizes, TextStyles} from '../index';
import {ComponentProps} from './ComponentProps';

export interface InputSearchFieldProps extends ComponentProps {
  text: string | null;
  onTextChanged: (text: string | null) => void;
  placeholder?: string;
  autoFocus?: boolean;
}

export const InputSearchField = (props: InputSearchFieldProps) => {
  return (
    <Pill
      color={Colors.neutralOff}
      testID={props.testID}
      paddingHorizontal={Sizes.s}
      containerStyle={props.containerStyle}>
      <InputSearchFieldBase {...{...props}} textInputStyle={[TextStyles.textMediumM, styles.textInput]} />
    </Pill>
  );
};

interface InputSearchFieldBaseProps extends InputSearchFieldProps {
  textInputStyle?: StyleProp<TextStyle>;
}

export const InputSearchFieldBase = (props: InputSearchFieldBaseProps) => {
  return (
    <View style={styles.container} testID={props.testID}>
      <SearchIcon testID={props.testID + '.SearchIcon'} />
      <TextInput
        autoFocus={props.autoFocus ?? false}
        style={[styles.textInputBase, props.textInputStyle]}
        testID={props.testID + '.TextInput'}
        placeholder={props.placeholder}
        placeholderTextColor={Colors.neutralLightAlpha}
        onChangeText={props.onTextChanged}
        value={props.text ?? undefined}
      />
      {(props.text ?? '').length > 0 && (
        <TouchableOpacity
          style={styles.clearIcon}
          onPress={() => props.onTextChanged(null)}
          activeOpacity={onPressOpacity}
          testID={props.testID + '.ClearButton'}>
          <CloseIcon testID={props.testID + '.ClearIcon'} />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textInputBase: {
    flex: 1,
    color: Colors.neutralDarkAlpha,
  },
  textInput: {
    paddingTop: 4,
  },
  clearIcon: {
    paddingLeft: Sizes.s,
    paddingRight: 4,
  },
});
